/*@ngInject*/
const ActionHandler = function (coreConstant) {

    this.getButtonBarActions = function (actions) {
        let allActions = _.flatten(_.map(actions, function (a) {
            return _.flatten(a);
        }));

        return _.filter(allActions, function (a) {
            return a.valid && a.buttonBarAction && !a.iwantToAction;
        }).sort(this.actionSortFunction);
    };

        this.getIWantToActions = function (actions, actionContexts, actionContextFallthrough) {
            var allActions = _.flatten(_.map(actions, function (a) {
                    return _.flatten(a);
                })),
                filteredActions = _.filter(allActions, function (a) {
                    if(a.iwantToAction && a.valid && !a.enabled && !_.isEmpty(a.notes) && !a.buttonBarAction) {
                        return true;
                    } else {
                        return a.enabled && a.valid && a.iwantToAction && !a.buttonBarAction;
                    }
                }).sort(this.actionSortFunction),
                actionsMap = {};

        _.forOwn(actionContexts, function (value, key) {
            actionsMap[key] = [];
        });
        actionsMap[actionContextFallthrough] = [];

        _.each(filteredActions, function (filteredAction) {
            let foundMapping = false;

            _.forOwn(actionContexts, function (value, key) {
                if (_.includes(filteredAction.context, value)) {
                    actionsMap[key].push(filteredAction);
                    foundMapping = true;
                    return false;
                } else if (key === coreConstant.CONTEXT_NONE) {
                    actionsMap[coreConstant.CONTEXT_NONE].push(filteredAction);
                    foundMapping = true;
                    return false;
                }
            });

            if (!foundMapping) {
                actionsMap[actionContextFallthrough].push(filteredAction);
            }
        });

        _.forOwn(actionContexts, function (value, key) {
            if (_.isEmpty(actionsMap[key])) {
                delete actionsMap[key];
            }
        });
        if (_.isEmpty(actionsMap[actionContextFallthrough])) {
            delete actionsMap[actionContextFallthrough];
        }

        return actionsMap;
    };

    /**
     * If child has next action -> Show child's next and previous actions
     * Else if parent has next action -> Show parent's next and previous actions
     * Else if child has previous action -> Show child's previous actions
     * Else if parent has previous action -> Show parent's previous actions
     */
    this.processContextActions = function (actions, hierarchicalContextList) {
        let nextActionCount = -1,
            previousActionCount = -1,
            contextActionObject;

        _.each(hierarchicalContextList, function (hierarchicalContext) {
            contextActionObject = _.find(actions, function (actionObject) {
                return actionObject.contextType === hierarchicalContext.contextType;
            });
            if (contextActionObject) {
                _.map(contextActionObject.actions, function (action) {
                    if (action.iwantToAction || action.buttonBarAction) {
                        if (action.nextAction) {
                            if (nextActionCount <= 0) {
                                action.iwantToAction = false;
                                action.buttonBarAction = true;
                            } else if (nextActionCount !== -1) {
                                action.iwantToAction = true;
                                action.buttonBarAction = false;
                            }
                        } else if (action.previousAction) {
                            if (previousActionCount <= 0) {
                                action.iwantToAction = false;
                                action.buttonBarAction = true;
                            } else if (previousActionCount !== -1) {
                                action.iwantToAction = true;
                                action.buttonBarAction = false;
                            }
                        } else if (action.iwantToAction && action.buttonBarAction){
                            action.buttonBarAction = false;
                        }
                    }
                });

                nextActionCount = _.filter(contextActionObject.actions, function (action) {
                    return action.nextAction && action.buttonBarAction && action.valid;
                }).length;
                previousActionCount = _.filter(contextActionObject.actions, function (action) {
                    return action.previousAction && action.buttonBarAction && action.valid;
                }).length;
            }
        });

        return actions;
    };

    this.actionSortFunction = function (action1, action2) {
        let sortValue = 0;

        // If both actions are on the button bar, or, if both actions' ordering are the same, we need to determine
        // their sort order via previousAction and nextAction before defaulting to calculating the sort solely
        // via the ordering values.
        if ((action1.buttonBarAction && action2.buttonBarAction) || action1.ordering === action2.ordering) {
            if (action2.previousAction) {
                sortValue = 1;
            } else if (action1.previousAction) {
                sortValue = -1;
            } else if (action2.nextAction) {
                sortValue = -1;
            } else if (action1.nextAction) {
                sortValue = 1;
            }
        }

        if (sortValue === 0) {
            sortValue = ( (action1.ordering - action2.ordering) > 0) ? 1 : -1;
        }

        return sortValue;
    };
};

angular.module('umCore')
    .service('actionHandler', ActionHandler);
